import Vue from 'vue';
import {handleErrors} from "@/services/ErrorHandling";

const self = Vue.prototype;

export default {

  countDontHaveInvoices(from, to) {
    return new Promise((resolve, reject) => {
      const url = `${self.$apiRouter.countWithoutShipping}/${from}/${to}`;
      self.axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  listDontHaveInvoices(date, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      const url = `${self.$apiRouter.listWithoutShipping}/${date}?page=${page}&per_page=${perPage}`;
      self.axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  countNotPaidMoreThanMonth(from, to) {
    return new Promise((resolve, reject) => {
      const url = `${self.$apiRouter.countNotPaidMoreThanMonth}/${from}/${to}`;
      self.axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  listNotPaidMoreThanMonth(date, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      const url = `${self.$apiRouter.listNotPaidMoreThanMonth}/${date}?page=${page}&per_page=${perPage}`;
      self.axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getFilteredOrders(url, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + `?page=${page}&per_page=${perPage}&${url}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getViewOrder(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrderView + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getViewOrderHistory(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrderViewHistory + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getOrderForUpdate(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminUpdateOrder + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  changeStatus(orderId, statusId) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminOrderChangeStatus, {order_id: orderId, status_id: statusId})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  changeWasPrinted(orderId, val) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminOrderChangeWasPrinted, {order_id: orderId, was_printed: val})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  changeLabelColor(orderId, color) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminOrderChangeLabelColor, {order_id: orderId, label_color: color})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  update(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUpdateOrder, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  create(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminOrder, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  delete(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminOrder + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  undoDelete(id) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminOrderUndoDelete + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  repack(id) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminOrderRepack + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteRepack(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminOrderRepack + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  duplicate(id) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminOrderDuplicate + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  createRequestForProcessing(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminRequestForProcessing, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getOrderAttachments(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrderAttachments + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  uploadAttachment(data) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminOrderAttachments, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  deleteAttachment(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminOrderAttachments + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  requestReturn(formData) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminOrderRequestReturn, formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  cancelReturn(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminOrderCancelReturn + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getStatusesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + '/statuses-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getShipmentMethodsMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + '/shipment-methods-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getShipmentTypesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + '/shipment-types-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getRecipientTypesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + '/recipient-types-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getFormTypesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + '/form-types-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

  getLabelColorsMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminOrder + '/label-colors-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

    getOverdueOrderedOrders(page = 1, perPage = 10) {
        return new Promise((resolve, reject) => {
            self.axios.get(self.$apiRouter.adminOverdueOrderedOrders + `?page=${page}&per_page=${perPage}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

}
